import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedMode } from 'components/KBQSelect'

const selectedDropdownModeSlice = createSlice({
  name: 'selectedDropdownMode',
  initialState: [] as SelectedMode[],
  reducers: {
    setSelectedDropdownMode(state, action: PayloadAction<SelectedMode>) {
      const { id, mode } = action.payload
      const existing = state.find((entry) => entry.id === id)
      if (existing) {
        existing.mode = mode
      } else {
        state.push({ id, mode })
      }
    },
  },
})
export const { setSelectedDropdownMode } = selectedDropdownModeSlice.actions
export default selectedDropdownModeSlice.reducer
